import { Button } from "@/components/ui/button";
import { MapPin, Building2, Users, Vote, CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const ClosingCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 relative overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-background to-accent/10" />
      
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-accent/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Tu Ciudad Fitness <span className="gradient-text">Te Espera</span>
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed">
            Únete a miles de personas que ya descubrieron una forma mejor de encontrar y crecer 
            en el mundo del fitness.
          </p>

          {/* Dual CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
            <Button 
              size="lg" 
              className="text-lg px-8 py-6 bg-gradient-primary hover:opacity-90 transition-opacity"
              onClick={() => navigate("/directorio")}
            >
              <MapPin className="w-5 h-5 mr-2" />
              Explorar Como Usuario
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="text-lg px-8 py-6 border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
              onClick={() => navigate("/registro-profesional")}
            >
              <Building2 className="w-5 h-5 mr-2" />
              Registrar Mi Negocio
            </Button>
          </div>

          {/* Trust line */}
          <div className="flex items-center justify-center gap-2 text-muted-foreground mb-10">
            <CheckCircle className="w-5 h-5 text-primary" />
            <span>Sin permanencia. Sin comisiones. Solo resultados.</span>
          </div>

          {/* Final stats */}
          <div className="flex flex-wrap justify-center gap-8 md:gap-12 pt-8 border-t border-border/50">
            <div className="flex items-center gap-2">
              <Users className="w-5 h-5 text-primary" />
              <span className="text-sm">
                <strong className="text-foreground">1,800+</strong>
                <span className="text-muted-foreground ml-1">Profesionales</span>
              </span>
            </div>
            <div className="flex items-center gap-2">
              <MapPin className="w-5 h-5 text-primary" />
              <span className="text-sm">
                <strong className="text-foreground">157</strong>
                <span className="text-muted-foreground ml-1">Ciudades</span>
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Vote className="w-5 h-5 text-primary" />
              <span className="text-sm">
                <strong className="text-foreground">45,000+</strong>
                <span className="text-muted-foreground ml-1">Votos de Confianza</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
